var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAlertTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.97473 3.59194C9.43041 2.80269 10.5696 2.80269 11.0253 3.59194L17.8396 15.3948C18.2953 16.184 17.7257 17.1706 16.8144 17.1706H3.18564C2.2743 17.1706 1.7047 16.184 2.16038 15.3948L8.97473 3.59194ZM10 7.42161C10.4359 7.42161 10.7893 7.77497 10.7893 8.21086V11.3679C10.7893 11.8037 10.4359 12.1571 10 12.1571C9.56412 12.1571 9.21076 11.8037 9.21076 11.3679V8.21086C9.21076 7.77497 9.56412 7.42161 10 7.42161ZM10 14.5249C10.4359 14.5249 10.7893 14.1715 10.7893 13.7356C10.7893 13.2997 10.4359 12.9464 10 12.9464C9.56412 12.9464 9.21076 13.2997 9.21076 13.7356C9.21076 14.1715 9.56412 14.5249 10 14.5249Z",
    fill: "#8A99A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAlertTriangle);
export default __webpack_public_path__ + "static/media/icon-alert-triangle.4937f3e9690e02b49a5e8c6ee1a6eb56.svg";
export { ForwardRef as ReactComponent };